@if (showMarketHelp) {
    <ms-market-help [optionGroup]="optionGroup" [eventHelpText]="eventHelpText" />
}
<div class="option-group-container outrights-container" [ngClass]="optionsClass">
    <div class="option-group-header">
        <span></span>
        @for (header of headerData; track trackHeader($index, header)) {
            <span>{{ header }} </span>
        }
    </div>
    @for (group of optionGroups | slice: 0 : visibleOptionsLimit; track trackGroup($index, group)) {
        <div class="attribute-key">
            <span class="attribute-key-ellipsis">{{ group.options[0].name }}</span>
        </div>
        @for (header of headerData; track trackHeader($index, header)) {
            @if (getOption(group.options, header); as option) {
                <ms-option
                    [tracking]="trackingSource"
                    [option]="option"
                    [optionGroup]="optionGroup"
                    [event]="event"
                    [showPromoBadge]="!!crmPromoIdsMap.options[option.id]"
                    [sourceOfPick]="sourceOfPick"
                    [betDetails]="betDetails" />
            } @else {
                <div class="option">
                    <div class="option-pick">
                        <div class="option-indicator">
                            <div class="lock" [class]="isEpcotEnabled ? 'option-group-lock-i-icon' : 'option-group-lock-icon'">
                                <vn-icon name="theme-locked-i" [size]="isEpcotEnabled ? '16' : '14'" />
                            </div>
                        </div>
                    </div>
                </div>
            }
        }
    }
</div>

@if (showMoreLessButtonVisible) {
    <div class="show-more-less-button" [ngClass]="{ expanded: expanded }" (click)="onShowMoreLessButtonToggle()">
        {{ expanded ? sitecore.event.ShowLess : sitecore.event.ShowMore }}
        <span class="right-icon"><vn-icon name="theme-right" size="12" /></span>
    </div>
}
